import { type OfferShippingsV1 } from '@redteclab/api/clients/bully'

export const shippingAccessorGetCheappestShipping = (
  marketplaceDeliveryCosts: OfferShippingsV1[],
): OfferShippingsV1 => {
  const [cheapestDeliveryOption] = marketplaceDeliveryCosts.toSorted(
    (deliveryA, deliveryB) => {
      if (typeof deliveryA.totalShippingPrice !== 'number') {
        return 1
      }

      if (typeof deliveryB.totalShippingPrice !== 'number') {
        return -1
      }

      return deliveryA.totalShippingPrice - deliveryB.totalShippingPrice
    },
  )

  return cheapestDeliveryOption
}
